
export const SEARCH_MODAL_SHOW = "SEARCH_MODAL_SHOW"

export const SEARCH_MODAL_HIDE = "SEARCH_MODAL_HIDE"

